(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["responsive_slideshow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  // pega esta instância
  const roots = document.querySelectorAll(".slideshow-responsivo");
  const root = roots[roots.length - 1];
  if (!root) return;

  const track  = root.querySelector(".slideshow-responsivo__track");
  const slides = Array.from(root.querySelectorAll(".slideshow-responsivo__slide"));
  const prevBtn = root.querySelector("[data-prev]");
  const nextBtn = root.querySelector("[data-next]");
  const dots   = Array.from(root.querySelectorAll("[data-dot]"));

  let index = 0;
  let timer = null;
  let currentVideo = null;

  const IMAGE_MS = 6000;       // 6s para imagem
  const VIDEO_FALLBACK = 40000; // 40s máx se a duração não estiver disponível

  function clearTimersAndListeners(){
    clearTimeout(timer);
    if (currentVideo){
      currentVideo.removeEventListener('ended', handleVideoEnded);
      currentVideo = null;
    }
  }

  function handleVideoEnded(){
    next(); // ao terminar o vídeo, vai pro próximo imediatamente
  }

  function scheduleAutoAdvance(){
    clearTimersAndListeners();

    const slide = slides[index];
    const v = slide.querySelector('video');

    if (v){
      currentVideo = v;
      // se o vídeo já tem duração conhecida, usa; senão, fallback 40s
      const maybeSchedule = () => {
        const hasDur = isFinite(v.duration) && v.duration > 0;
        const ms = hasDur ? v.duration * 1000 : VIDEO_FALLBACK;
        // backup em caso de falha no evento 'ended'
        timer = setTimeout(() => next(), ms + 50);
      };

      v.addEventListener('ended', handleVideoEnded, { once: true });
      if (v.readyState >= 1){
        maybeSchedule();
      } else {
        v.addEventListener('loadedmetadata', maybeSchedule, { once: true });
        // também dá o play se necessário
        v.play().catch(()=>{});
      }
    } else {
      timer = setTimeout(() => next(), IMAGE_MS);
    }
  }

  function updateDots(){
    dots.forEach((b, j) => b.classList.toggle("active", j === index));
  }

  function goTo(i, { user=false } = {}){
    if (i < 0) i = slides.length - 1;
    if (i >= slides.length) i = 0;
    index = i;
    track.scrollTo({ left: slides[i].offsetLeft, behavior: "smooth" });
    updateDots();

    // se for vídeo, garante play
    const v = slides[i].querySelector('video');
    if (v){
      v.play().catch(()=>{});
    }

    scheduleAutoAdvance();
  }

  function next(){ goTo(index + 1, { user:true }); }
  function prev(){ goTo(index - 1, { user:true }); }

  // eventos
  nextBtn && nextBtn.addEventListener("click", next);
  prevBtn && prevBtn.addEventListener("click", prev);
  dots.forEach(btn => btn.addEventListener("click", () => {
    const i = parseInt(btn.dataset.dot, 10);
    if (!Number.isNaN(i)) goTo(i, { user:true });
  }));

  // swipe (mobile)
  let startX = null;
  track.addEventListener("pointerdown", e => { startX = e.clientX; });
  track.addEventListener("pointerup", e => {
    if (startX === null) return;
    const dx = e.clientX - startX;
    if (Math.abs(dx) > 40) (dx < 0 ? next() : prev());
    startX = null;
  }, { passive:true });

  // init
  updateDots();
  goTo(0);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-1290x473"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(".sl1290");
  sections.forEach((root) => {
    const track   = root.querySelector(".sl1290__track");
    const slides  = Array.from(root.querySelectorAll(".sl1290__slide"));
    const prevBtn = root.querySelector("[data-prev]");
    const nextBtn = root.querySelector("[data-next]");
    const dots    = Array.from(root.querySelectorAll("[data-dot]"));
    const autoplayEnabled = root.dataset.autoplay === "true";

    let index = 0;
    let timer = null;
    let currentVideo = null;

    const IMAGE_MS = 6000;
    const VIDEO_FALLBACK = 40000;

    function clearTimersAndListeners(){
      clearTimeout(timer);
      if (currentVideo){
        currentVideo.removeEventListener('ended', handleVideoEnded);
        currentVideo = null;
      }
    }
    function handleVideoEnded(){ next(); }
    function updateDots(){ dots.forEach((b, j) => b.classList.toggle("active", j === index)); }

    function scheduleAutoAdvance(){
      if (!autoplayEnabled) return;
      clearTimersAndListeners();
      const slide = slides[index];
      const v = slide.querySelector('video');

      if (v){
        currentVideo = v;
        const maybeSchedule = () => {
          const hasDur = isFinite(v.duration) && v.duration > 0;
          const ms = hasDur ? v.duration * 1000 : VIDEO_FALLBACK;
          timer = setTimeout(() => next(), ms + 50);
        };
        v.addEventListener('ended', handleVideoEnded, { once: true });
        if (v.readyState >= 1){ v.loop = false; maybeSchedule(); v.play().catch(()=>{}); }
        else { v.addEventListener('loadedmetadata', () => { maybeSchedule(); v.play().catch(()=>{}); }, { once:true }); }
      } else {
        timer = setTimeout(() => next(), IMAGE_MS);
      }
    }

    function goTo(i, { user=false } = {}){
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      index = i;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: "smooth" });
      updateDots();
      const v = slides[i].querySelector('video');
      if (v){ if (v.ended) v.currentTime = 0; v.play().catch(()=>{}); }
      scheduleAutoAdvance();
    }

    function next(){ goTo(index + 1, { user:true }); }
    function prev(){ goTo(index - 1, { user:true }); }

    nextBtn && nextBtn.addEventListener("click", next);
    prevBtn && prevBtn.addEventListener("click", prev);
    dots.forEach(btn => btn.addEventListener("click", () => {
      const i = parseInt(btn.dataset.dot, 10);
      if (!Number.isNaN(i)) goTo(i, { user:true });
    }));

    let startX = null;
    track.addEventListener("pointerdown", e => { startX = e.clientX; });
    track.addEventListener("pointerup", e => {
      if (startX === null) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 40) (dx < 0 ? next() : prev());
      startX = null;
    }, { passive:true });

    updateDots();
    goTo(0);
  });
});

  } catch(e) { console.error(e); }
})();
})();
